export var PreviewType;
(function (PreviewType) {
    PreviewType["Archive"] = "archive";
    PreviewType["Audio"] = "audio";
    PreviewType["CloudDoc"] = "cloud_doc";
    PreviewType["Excel"] = "excel";
    PreviewType["Error"] = "error";
    PreviewType["Text"] = "text";
    PreviewType["Image"] = "image";
    PreviewType["Linkfile"] = "linkfile";
    PreviewType["Other"] = "other";
    PreviewType["SsrDoc"] = "ssr_doc";
    PreviewType["RawHTML"] = "raw_html";
    PreviewType["Restricted"] = "restricted";
    PreviewType["Video"] = "video";
    PreviewType["Loading"] = "loading";
    // deprected Preview Types, keeping for backward compatibility
    // remove when File.preview_type is gone
    /** @deprecated Use SsrDoc */
    PreviewType["Doc"] = "doc";
    /** @deprecated Use Image */
    PreviewType["Photo"] = "photo";
})(PreviewType || (PreviewType = {}));
//# sourceMappingURL=preview_type.preenvesnextjs.map
